import { render, staticRenderFns } from "./TableListConfig.vue?vue&type=template&id=f9a8ed78&scoped=true&"
import script from "./TableListConfig.vue?vue&type=script&lang=ts&"
export * from "./TableListConfig.vue?vue&type=script&lang=ts&"
import style0 from "./TableListConfig.vue?vue&type=style&index=0&id=f9a8ed78&lang=less&scoped=true&"
import style1 from "./TableListConfig.vue?vue&type=style&index=1&id=f9a8ed78&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f9a8ed78",
  null
  
)

export default component.exports